import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { api, fmtErr } from "../api";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function NewVerificationDialog({ open, onOpenChange }) {
  const navigate = useNavigate();
  const [form, setForm] = useState({ address: "", survey_number: "", village: "", taluk: "", district: "", property_type: "Residential" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/verifications", form);
      toast.success("Verification request created. Now upload your documents.");
      onOpenChange(false);
      navigate(`/verification/${data.id}`);
    } catch (err) {
      toast.error(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="new-verification-dialog">
        <DialogHeader>
          <DialogTitle>New Property Verification</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="v-address">Complete Property Address *</Label>
            <Input id="v-address" required data-testid="verification-address-input" value={form.address} onChange={set("address")}
              placeholder="No. 12, 3rd Cross, Sample Layout, Bengaluru 5600XX" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1.5">
              <Label htmlFor="v-survey">Survey No. / Plot No.</Label>
              <Input id="v-survey" data-testid="verification-survey-input" value={form.survey_number} onChange={set("survey_number")} placeholder="Survey No. 45/2" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="v-village">Village / Locality</Label>
              <Input id="v-village" data-testid="verification-village-input" value={form.village} onChange={set("village")} placeholder="Whitefield" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="v-taluk">Taluk</Label>
              <Input id="v-taluk" data-testid="verification-taluk-input" value={form.taluk} onChange={set("taluk")} placeholder="Bengaluru East" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="v-district">District</Label>
              <Input id="v-district" data-testid="verification-district-input" value={form.district} onChange={set("district")} placeholder="Bengaluru Urban" />
            </div>
          </div>
          <div className="space-y-1.5">
            <Label>Property Type</Label>
            <Select value={form.property_type} onValueChange={(v) => setForm((f) => ({ ...f, property_type: v }))}>
              <SelectTrigger data-testid="verification-type-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                {["Residential", "Commercial", "Plot / Land", "Agricultural"].map((t) => (
                  <SelectItem key={t} value={t} data-testid={`verification-type-${t.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{t}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="verification-create-submit">
            {loading ? "Creating…" : "Create & Upload Documents"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
